'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import angularLoadingBar from 'angular-loading-bar';

import uiRouter from 'angular-ui-router';

import 'angular-validation-match';

import {
    routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import users from './admin/users/users.component';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import help from './help/help.component';
import dashboard from './account/dashboard/dashboard.component';
import myaccount from './account/myaccount/myaccount.component';
import createaccount from './account/createaccount/createaccount.component';
import map from './account/map/map.component';
import data from './account/data/data.component';
import zoning from './account/zoning/zoning.component';
import gp from './account/gp/gp.component';
import report from './feedback/feedback.component';
import feedback from './account/report/report.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import forgotpassword from './account/forgotpassword/forgotpassword.component';
import basecodes from './account/basecodes/basecodes.component';
import sources from './sources/sources.component';
import detail from './detail/detail.component';
import affh from './account/affh/affh.component';

// Services 
import landuseService from '../components/services/landuse/landuse.service';
import lookupService from '../components/services/lookup/lookup.service';
import mapService from '../components/services/map/map.service';
import themeService from '../components/services/theme/theme.service';
import dbService from '../components/services/db/db.service';

// Factories 
import dbFactoryService from '../components/factories/dbFactory/dbFactory.service';

// Angular Smart Table 
import smartTable from 'angular-smart-table';

//UUID
require("angular-uuid");

import './app.css';

angular.module('hessApp', [ngCookies, ngResource, ngSanitize, uiRouter, _Auth, smartTable, account, admin, users, 'angular-uuid',angularLoadingBar, sources, detail,landuseService,lookupService, mapService,themeService,
        'validation.match',dbService, dbFactoryService, navbar, footer, main, feedback, help, dashboard,myaccount,createaccount,forgotpassword,basecodes, map, data,zoning, gp, report, affh, constants, util
    ])
    .config(routeConfig)
    .run(function($rootScope, $location, Auth) {
        'ngInject';
        // Redirect to login if route requires auth and you're not logged in

        $rootScope.$on('$stateChangeStart', function(event, next) {
            Auth.isLoggedIn(function(loggedIn) {
                if (next.authenticate && !loggedIn) {
                    $location.path('/');
                }
            });
        });
    });

angular.element(document)
    .ready(() => {
        angular.bootstrap(document, ['hessApp'], {
            strictDi: true
        });
    });


// WEBPACK FOOTER //
// ./client/app/app.js